export default "__VITE_ASSET__BXXeFRdX__"